module.exports = __webpack_public_path__ + "img/c3.d8ec27d1.png";